export const ultraShortLength = 50;
export const shortLength = 80;
export const longLength = 100;
